<template>
  <div class="main main-tabbar">
    <PhoneSelector></PhoneSelector>
  </div>
</template>

<script>

import ActionButton from '@/components/products/form/ActionButton'
import PhoneSelector from '@/components/common/PhoneSelector'
import api from '../../api'

import VantButton from 'vant/lib/button';



export default {
  title: '手机号码',
  bodyClass:'gray-bg',
  components: { ActionButton, PhoneSelector},
  data () {
    return {
    }
  },
  methods:{
    
  },
  mounted(){
    // this.$showLoading('加载中...');
    // this.$hideLoading();
  }
}
</script>

<style scoped lang="less">
.main{

}

</style>



// WEBPACK FOOTER //
// src/pages/setting/Phones.vue